import { useEffect, type ReactElement } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { GoogleAnalyticsTracker } from './GoogleAnalyticsTracker';
import { Layout } from './Layout';
import { HomePage } from '../pages/HomePage';
import { CategoryPage } from '../pages/CategoryPage';
import { SaaSToolsPage } from '../pages/SaaSToolsPage';
import { SkillsPage } from '../pages/SkillsPage';
import { PromptsPage } from '../pages/PromptsPage';
import { AuthorPage } from '../pages/AuthorPage';
import { BlogPage, InfoPage, SearchPage } from '../pages/PublicPages';
import { AboutPage } from '../pages/AboutPage';
import { PartnersPage } from '../pages/PartnersPage';
import { PolicyPage } from '../pages/PolicyPage';
import { MatcherPage } from '../pages/MatcherPage';
import { ComparePage } from '../pages/ComparePage';

const routes: Array<[string, ReactElement]> = [
  ['/', <HomePage />],
  ['/categories/:slug', <CategoryPage />],
  ['/saas-tools', <SaaSToolsPage />],
  ['/skills', <SkillsPage />],
  ['/prompts', <PromptsPage />],
  ['/authors/:id', <AuthorPage />],
  ['/blog', <BlogPage />],
  ['/blog/:slug', <BlogPage />],
  ['/about', <AboutPage />],
  ['/about/partners', <PartnersPage />],
  ['/about/privacy', <PolicyPage kind="privacy" />],
  ['/about/terms', <PolicyPage kind="terms" />],
  ['/about/editorial-policy', <InfoPage kind="editorial" />],
  ['/about/community-guidelines', <InfoPage kind="community" />],
  ['/matcher', <MatcherPage />],
  ['/compare', <ComparePage />],
  ['/search', <SearchPage />],
];

function DocumentNavigation() {
  const location = useLocation();
  useEffect(() => {
    window.location.assign(`${location.pathname}${location.search}${location.hash}`);
  }, [location]);
  return null;
}

function InitialPage({ pathname, page }: { pathname: string; page: ReactElement }) {
  const location = useLocation();
  return location.pathname.replace(/\/+$/, '') === pathname.replace(/\/+$/, '')
    ? page : <DocumentNavigation />;
}

/** One route table is used by the build renderer and browser hydration entry. */
export function PublicDocument({ pathname }: { pathname: string }) {
  const location = useLocation();
  return <>
    <GoogleAnalyticsTracker active={location.pathname.replace(/\/+$/, '') === pathname.replace(/\/+$/, '')} />
    <Layout>
      <Routes>
        {routes.flatMap(([route, page]) => [
          <Route key={route} path={route} element={<InitialPage pathname={pathname} page={page} />} />,
          <Route key={`zh${route}`} path={route === '/' ? '/zh' : `/zh${route}`}
            element={<InitialPage pathname={pathname} page={page} />} />,
        ])}
        <Route path="*" element={<DocumentNavigation />} />
      </Routes>
    </Layout>
  </>;
}
